import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="mb-4 flex items-center gap-3 font-mono text-xs font-medium uppercase tracking-[0.3em] text-[#00F0FF]">
    <span className="h-px w-8 bg-[#00F0FF]/60" />
    {children}
  </p>
);
